import subSeconds from 'date-fns/sub_seconds'
import addMinutes from 'date-fns/add_minutes'
import format from 'date-fns/format'
// upon logout
export const flushStorage = () => {
  localStorage.removeItem('token:user_id')
  localStorage.removeItem('token:jwt')
  localStorage.removeItem('token:jwt_exp')
  localStorage.removeItem('token:rft')
  localStorage.removeItem('token:remember')
  localStorage.removeItem('me')
  localStorage.removeItem('session')
}

// upon login and delegate
export const setLoginStorage = (token) => {
  localStorage.setItem('token:user_id', token.user_id)
  localStorage.setItem('token:jwt', token.jwt)
  // localStorage.setItem('token:jwt_exp', moment().add(token.jwt_exp, 'm').subtract(30, 's').valueOf()) // in milliseconds // subtract 30 secs to refresh 30 secs ahead
  localStorage.setItem('token:jwt_exp', format(subSeconds(addMinutes(new Date(), token.jwt_exp), 30), 'x'))
  localStorage.setItem('token:rft', token.rft)
  localStorage.setItem('token:remember', token.remember)
}

// upon /users/me
export const setMe = (me) => {
  localStorage.setItem('me', JSON.stringify(me))
}

export const setEmail = (email) => {
  let me = JSON.parse(localStorage.getItem('me'))
  me.email = email
  localStorage.setItem('me', JSON.stringify(me))
}

// upon /users/me
export const setSession = (session) => {
  localStorage.setItem('session', JSON.stringify(session))
}



// WEBPACK FOOTER //
// ./src/utils/storage.js